function renderProp(_a) {
    var prop = _a.prop, context = _a.context, _b = _a.fallback, fallback = _b === void 0 ? null : _b;
    if (!prop)
        return fallback;
    return prop instanceof Function ? prop(context) : prop;
}

export { renderProp };
//# sourceMappingURL=renderProp.js.map
